export default __webpack_public_path__ + "static/media/NatureProtofoilo.61e3c066.jpg";